// eslint-disable-next-line import/extensions
import { ONE_SECOND_MILLIS, ONE_MINUTE_SECONDS } from '../data/consts.js';

class GameTimer {
  constructor(gameTime) {
    this.gameTime = gameTime;
    this.stopGame = false;
    this.timer = null; // Store timer reference
  }

  setGameTime(newGameTime) {
    this.gameTime = newGameTime;
  }

  runTimer(callbackOnInterval, callbackOnEndOfTime) {
    // Clear any existing timer first
    if (this.timer) {
      console.log('Clearing existing timer');
      clearInterval(this.timer);
      this.timer = null;
    }

    this.stopGame = false;
    const initialTimeInMilisec =
      this.gameTime * ONE_MINUTE_SECONDS * ONE_SECOND_MILLIS;
    const totalTimeInSec = this.gameTime * ONE_MINUTE_SECONDS;
    const timeInterval = ONE_SECOND_MILLIS;
    let timeLeft = initialTimeInMilisec;

    // Call immediately to render wand at start
    callbackOnInterval(timeLeft / ONE_SECOND_MILLIS, totalTimeInSec);

    this.timer = setInterval(() => {
      if (this.stopGame === true) {
        clearInterval(this.timer);
        this.timer = null;
        timeLeft = initialTimeInMilisec;
      } else if (timeLeft <= 0) {
        clearInterval(this.timer);
        this.timer = null;
        timeLeft = initialTimeInMilisec;
        callbackOnEndOfTime();
      } else {
        timeLeft -= timeInterval;
        const timeLeftInSec = timeLeft / ONE_SECOND_MILLIS;
        callbackOnInterval(timeLeftInSec, totalTimeInSec);
      }
    }, timeInterval);
  }
}
export default GameTimer;
